export const filtrarUbication = (listUbicationProvider, values) => {
  return listUbicationProvider?.filter(
    (prove) => prove.entidadId === values?.proveiderStock
  );
};